import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import {
    Nav,
    NavbarContainer,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
} from "./NavbarElements";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";

const Navbar = ({ toggle }) => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollNav(true);
        } else {
            setScrollNav(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", changeNav);
    }, []);

    const toggleHome = () => {
        scroll.scrollToTop();
    };

    return (
        <>
            <IconContext.Provider value={{ color: "#fff" }}>
                <Nav scrollNav={scrollNav}>
                    <NavbarContainer>
                        <NavLogo to="/" onClick={toggleHome}>
                            Sourabh
                        </NavLogo>
                        <MobileIcon onClick={toggle}>
                            <FaBars />
                        </MobileIcon>
                        <NavMenu>
                            <NavItem>
                                <NavLinks
                                    to="about"
                                    smooth={true}
                                    duration={500}
                                    spy={true}
                                    exact="true"
                                >
                                    About
                                </NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks
                                    to="work-experience"
                                    smooth={true}
                                    duration={500}
                                    spy={true}
                                    exact="true"
                                >
                                    Work Experience
                                </NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks
                                    to="certifications"
                                    smooth={true}
                                    duration={500}
                                    spy={true}
                                    exact="true"
                                >
                                    Certifications
                                </NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks
                                    to="skills"
                                    smooth={true}
                                    duration={500}
                                    spy={true}
                                    exact="true"
                                >
                                    Skills
                                </NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks
                                    to="education"
                                    smooth={true}
                                    duration={500}
                                    spy={true}
                                    exact="true"
                                >
                                    Education
                                </NavLinks>
                            </NavItem>
                        </NavMenu>
                    </NavbarContainer>
                </Nav>
            </IconContext.Provider>
        </>
    );
};

export default Navbar;
